import { ConvexReactClient } from "convex/react";

// NEVER hardcode a *.convex.cloud URL. The deployment URL is a build-time public
// var (Vite bakes it into the bundle). If it is missing we THROW rather than fall
// back to a placeholder — a silent `new ConvexReactClient(undefined)` fails
// invisibly, which is the worst failure mode (see ~/.claude/rules/convex.md).
const convexUrl = import.meta.env.VITE_CONVEX_URL;
if (!convexUrl) {
  throw new Error(
    "VITE_CONVEX_URL is not set — check .env.local (Tenant Zero prod deployment).",
  );
}

export const convex = new ConvexReactClient(convexUrl);
